import { styled } from "solid-styled-components";

export const IconButtonWrapper = styled.button`
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  ${({ theme }) => `
  	background: ${theme?.colors.background};
	color: ${theme?.colors.accentTertiary};
  `}
  @media only screen and (max-width: 370px) {
    width: 30px;
    height: 30px;
    svg {
      font-size: 18px;
    }
  }
`;

export const NotificationDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${({ theme }) => theme?.colors.accentPrimary};
  position: absolute;
  top: 5px;
  right: 5px;
`;
